import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './Placeholder.module.scss'
import colors from '../../../assets/styles/globals.scss'
import SubmitButton from '../../common/buttons/SubmitButton'
import { ReactComponent as LeaderboardIcon } from '../../../assets/images/common/icons/leaderboard-icon.svg'

const Placeholder = ({ eventInProgress, logScores, savedScoresCount, isDraft }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.placeholderWrapper}>
      <div className={styles.placeholderContainer}>
        <LeaderboardIcon fill={eventInProgress ? colors.primaryOrange : colors.placeholderGray} className='mb-3'/>
        {isDraft
          ? <>
            <p className={styles.title}>{t('events.detail.placeholder.noLeaderboard')}</p>
            <p className={styles.description}>
              {t('events.detail.placeholder.draftDescription')}
            </p>
          </>
          : eventInProgress
            ? <>
              <p className={styles.title}>{t('events.detail.placeholder.scoringInProgress')}</p>

              <p className={styles.description}>
                {t('events.detail.placeholder.inProgressDescription', { count: savedScoresCount })}
              </p>

              <div className={styles.logScoresButton}>
                <SubmitButton
                  onClick={logScores}
                  buttonMessage={t('events.detail.placeholder.continueLogging')}
                  buttonColor='orange-button'
                />
              </div>
            </>
            : <>
              <p className={styles.title}>{t('events.detail.placeholder.noLeaderboard')}</p>

              <p className={styles.description}>
                {t('events.detail.placeholder.beginLoggingDescription')}
              </p>

              <div className={styles.logScoresButton}>
                <SubmitButton
                  onClick={logScores}
                  buttonMessage={t('events.common.logScores')}
                  buttonColor='orange-button'
                />
              </div>
            </>
        }
      </div>
    </div>
  )
}

Placeholder.propTypes = {
  eventInProgress: PropTypes.bool,
  logScores: PropTypes.func.isRequired,
  savedScoresCount: PropTypes.number,
  isDraft: PropTypes.bool,
}

export default Placeholder
